<template>
  <a-modal
    ref="createModal"
    title="新建班次"
    :width="1000"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form">
      <a-row :gutter="12">
        <a-col :md="6" :sm="24">
          <a-form-item label="班次名称">
            <a-input v-decorator="['shiftsName', { rules: [{ required: true, message: '请输入班次名称' }] }]" />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="说明">
            <a-input v-decorator="['description']" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="tableList"
      :pagination="false"
      row-key="indexId"
    >
      <!-- 起始时间 -->
      <span slot="startTimeShiftsTitle">
        <i class="toRequired">*</i>起始时间
      </span>
      <template slot="startTimeShifts" slot-scope="text, record">
        <a-time-picker v-model="record.startTimeShifts" @change="(time, timeString) => startTimeShiftsOnChange(time, timeString, record)" />
      </template>
      <!-- 终止时间 -->
      <span slot="endTimeShiftsTitle">
        <i class="toRequired">*</i>终止时间
      </span>
      <template slot="endTimeShifts" slot-scope="text, record">
        <EndTimePicker v-model="record.endTimeShifts" :start-time="new Date(record.startTimeShifts)" @change="(time, timeString) => endTimeShiftsOnChange(time, timeString, record)" />
      </template>
      <!-- 标准停顿时长（分） -->
      <span slot="pauseDurationStandardTitle">
        <i class="toRequired">*</i>标准停顿时长（分）
      </span>
      <template slot="pauseDurationStandard" slot-scope="text, record">
        <a-input-number v-model="record.pauseDurationStandard" :min="0" @change="(str) => pauseDurationStandardChange(str, record)" />
      </template>
      <!-- 备注 -->
      <template slot="notes" slot-scope="text, record">
        <a-input v-model="record.notes" />
      </template>
      <!-- 工作时长 -->
      <template slot="workingHours" slot-scope="text, record">
        <a-input v-model="record.workingHours" disabled />
      </template>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(tableList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { apiRoutingCalendarAddShiftsHead } from '@/api/mes/calendar/frequencyInformation'
import EndTimePicker from '@/components/EndTimePicker/EndTimePicker';
import { calculateTimeDifference } from '@/utils/time'

import moment from 'moment';
// 表单字段
export default {
  props: {},
  components: {
    EndTimePicker
  },
  data () {
    return {
      form: this.$form.createForm(this),
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '起始时间',
          width: 140,
          dataIndex: 'startTimeShifts',
          scopedSlots: { customRender: 'startTimeShifts', title: "startTimeShiftsTitle" }
        },
        {
          // title: '终止时间',
          width: 140,
          dataIndex: 'endTimeShifts',
          scopedSlots: { customRender: 'endTimeShifts', title: "endTimeShiftsTitle" }
        },
        {
          // title: '标准停顿时长（分）',
          width: 170,
          dataIndex: 'pauseDurationStandard',
          scopedSlots: { customRender: 'pauseDurationStandard', title: "pauseDurationStandardTitle" }
        },
        {
          title: '备注',
          width: 140,
          dataIndex: 'notes',
          scopedSlots: { customRender: 'notes' }
        },
        {
          title: '工作时长',
          width: 140,
          dataIndex: 'workingHours',
          scopedSlots: { customRender: 'workingHours' }
        },
        {
          title: '操作',
          width: 80,
          dataIndex: 'operation',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      tableList: []
    }
  },
  created () {},
  methods: {
    // 标准停顿时长（分）
    pauseDurationStandardChange (val, record) {
      this.getWorkingHours("wh", "wh", val, record)
    },
    moment,
    // 终止时间
    endTimeShiftsOnChange (time, timeString, record) {
      record.endTimeShifts = this.moment(timeString, 'HH:mm:ss')
      this.getWorkingHours(record.startTimeShifts, time, record.pauseDurationStandard, record)
    },
    // 起始时间
    startTimeShiftsOnChange (time, timeString, record) {
      record.startTimeShifts = this.moment(timeString, 'HH:mm:ss')
      this.getWorkingHours(time, record.endTimeShifts, record.pauseDurationStandard, record)
    },
    getWorkingHours (val1, val2, val3, record) {
      if (!val1 || !val2) {
        return
      }
      const params = {
        startTimeShifts: String(this.$moment(val1 === "wh" ? record.startTimeShifts : val1).format('YYYY-MM-DD HH:mm:ss')),
        endTimeShifts: String(this.$moment(val1 === "wh" ? record.endTimeShifts : val2).format('YYYY-MM-DD HH:mm:ss')),
        pauseDurationStandard: val3 ? String(val3) : 0
      }
      record.workingHours = calculateTimeDifference(params.startTimeShifts, params.endTimeShifts, params.pauseDurationStandard)
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.tableList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        startTimeShifts: "",
        endTimeShifts: "",
        pauseDurationStandard: "",
        notes: "",
        workingHours: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.tableList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.tableList.length; i++) {
        if (!this.tableList[i].startTimeShifts || !this.tableList[i].endTimeShifts || (!this.tableList[i].pauseDurationStandard && Number(this.tableList[i].pauseDurationStandard !== 0))) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          const params = this.form.getFieldsValue()
          params.bomRoutingWorkingTimeDtoList = this.tableList
          apiRoutingCalendarAddShiftsHead(params).then(response => {
            if (response.code === 200) {
              this.$message.success('新增成功')
              // 关闭本组件
              this.visible = false
              // 调用外部刷新列表方法
              this.$emit('handle-success')
              // 刷新表单
              this.reset()
              this.confirmLoading = false
            } else {
              this.$message.error(response.msg)
              this.confirmLoading = false
            }
          }).catch(e => {
            this.confirmLoading = false
          })
        }
      });
    },
    // 表单重置
    reset () {
      this.form.resetFields()
      this.tableList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 140px;
}
/deep/.ant-input-number{
  width: 140px;
}
input{
  width: 140px
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
/deep/.ant-form-item{
  display: flex;
}
</style>
